import { render } from "./Book_Hotel.vue?vue&type=template&id=10f4be03&scoped=true"
import script from "./Book_Hotel.vue?vue&type=script&lang=js"
export * from "./Book_Hotel.vue?vue&type=script&lang=js"

import "./Book_Hotel.vue?vue&type=style&index=0&id=10f4be03&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f4be03"]])

export default __exports__